import { render, staticRenderFns } from "./ConnectedUserForm.vue?vue&type=template&id=54b40286&"
import script from "./ConnectedUserForm.vue?vue&type=script&lang=js&"
export * from "./ConnectedUserForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports